export default ({ store }, inject) => {
	if (process.client) {
		try {
			store.dispatch('cookieConsent/initFromStorage')
		} catch (e) {
			if (process.env.DEPLOY_ENV !== 'production') {
				console.warn('Cookie consent initialization failed:', e)
			}
		}
	}

	inject('cookieConsent', {
		hasAnswered() {
			return Boolean(store.getters['cookieConsent/hasAnswered'])
		},
		isAllowed(category) {
			return Boolean(
				store.getters['cookieConsent/categoryEnabled'](category)
			)
		}
	})
}
